import { sort } from '../../utils/helpers';
import actionHelpers from '../../utils/action-helpers';
import getterHelpers from '../../utils/getter-helpers';
import mutationHelpers from '../../utils/mutation-helpers';
const path = process.env.VUE_APP_ROOT_API;

// TODO: move grouping actions to grouping module that returns whatever ponies are fetched from the url param

const state = {
  status: null,
  items: [],
  heading: 'Molds',
  description: '',
  nextUrl: null,
  total: null,
  errors: [],
  filters: [],
  displayStyle: 'grid',
  sort: {
    direction: 'asc',
    field: 'name'
  }
};

const actions = {
  RESET_ERRORS: actionHelpers.RESET_ERRORS,
  RESET_STATUS: actionHelpers.RESET_STATUS,
  CLEAR_ITEMS: ({ commit }) => {
    commit('CLEAR_ITEMS');
  },
  FETCH_ALL: ({ commit, dispatch }, payload) => {
    // fetch an initial list of molds
    commit('CLEAR_ITEMS');

    const sort = () =>
      dispatch('SORT', {
        direction: state.sort.direction,
        field: state.sort.field
      });

    actionHelpers.FETCH_ALL(`${path}/api/molds/${payload.num}`, sort)({
      commit,
      dispatch
    });
  },
  FETCH_MORE: ({ commit, dispatch }) => {
    // fetch the next page of mold if there is a next page
    actionHelpers.FETCH_MORE(state.nextUrl)({ commit, dispatch });
  },
  FETCH: ({ commit, dispatch }, { slug, num }) => {
    const fetchPonies = () => {
      actionHelpers.FETCH_PONIES(
        `${path}/api/mold/${slug}/ponies/${num}`
      )({ commit, dispatch }, { id: slug, num });
    };

    actionHelpers.FETCH(`${path}/api/mold/${slug}`, fetchPonies)(
      { commit, dispatch },
      { slug, num },
      state
    );
  },
  FETCH_PONIES: ({ commit, dispatch }, { id, num }) => {
    actionHelpers.FETCH_PONIES(
      `${path}/api/mold/${id}/ponies/${num}`
    )({ commit, dispatch }, { id });
  },
  FETCH_MORE_PONIES: async ({ commit, dispatch }, { id, url }) => {
    actionHelpers.FETCH_MORE_PONIES(url)({ commit, dispatch }, { id });
  },
  ADD: async ({ commit, dispatch }, payload) => {
    actionHelpers.ADD(`${path}/api/mold/create`)({ commit, dispatch }, payload);
  },
  UPDATE: async ({ commit, dispatch }, payload) => {
    actionHelpers.UPDATE(`${path}/api/mold/${payload.id}`)(
      { commit, dispatch },
      payload
    );
  },
  REMOVE: async ({ commit, dispatch }, payload) => {
    actionHelpers.REMOVE(`${path}/api/mold/${payload.id}`)(
      { commit, dispatch },
      payload
    );
  },
  CHANGE_DISPLAY_STYLE: ({ commit }, { display }) => {
    commit('UPDATE_DISPLAY_STYLE', { display });
  },
  SORT: ({ commit }, { direction, field }) => {
    commit('SORT_MOLDS', { direction, field });
  }
};

const mutations = {
  UPDATE_DISPLAY_STYLE(state, { display }) {
    state.displayStyle = display;
  },
  SORT_MOLDS(state, { direction, field = 'name' }) {
    state.sort = { direction, field };

    if (state.items && state.items.length) {
      state.items = sort([...state.items], direction, field);
    }
  },
  CLEAR_ITEMS(state) {
    state.items = [];
  }
};

export default {
  namespaced: true,
  state,
  getters: { ...getterHelpers },
  actions,
  mutations: { ...mutationHelpers, ...mutations }
};
